import { useEffect } from "react";

/**
 * Hook pour gérer le SEO dynamique des pages
 * @param {Object} options - Options SEO
 * @param {string} options.title - Titre de la page
 * @param {string} options.description - Meta description
 */
export function useSEO({ title, description }) {
  useEffect(() => {
    // Titre de la page
    const fullTitle = title
      ? `${title} | AT Outils Immobiliers`
      : "Outils Immobiliers Gratuits | Simulateur Crédit, Frais Notaire - AT Outils";
    document.title = fullTitle;

    // Meta description
    if (description) {
      let metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute("content", description);
      }
    }

    // Open Graph title
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle && title) {
      ogTitle.setAttribute("content", fullTitle);
    }

    // Open Graph description
    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription && description) {
      ogDescription.setAttribute("content", description);
    }
  }, [title, description]);
}

export default useSEO;
